import {publicProperties} from '@netx/core-app/collections/singleton/publicProperties';

export const getPublicProperty = <Bool extends boolean = false>(
	key: string,
	asBoolean?: Bool,
) => {
	return (
		asBoolean ? publicProperties.isTrue(key) : publicProperties.getProperty(key)
	) as Bool extends true ? boolean : string | undefined;
};

export default getPublicProperty;
